import { Link } from 'react-router-dom'
import styled from 'styled-components/macro'

export const VENUE_GROUP_NONE_LABEL = 'No group'

/** Normalize list/API rows into chip targets. */
export const venueGroupChipItems = groups =>
  (groups || [])
    .map(group => ({
      _id: group?._id,
      name: String(group?.name || '').trim() || 'Group',
    }))
    .filter(group => group._id)

/**
 * Chips that open a group — same affordance on the venues list and venue Home.
 * stopPropagation keeps a list-card click from stealing the open.
 */
const VenueGroupMembershipChips = ({
  groups,
  emptyLabel = VENUE_GROUP_NONE_LABEL,
  'data-testid': testId = 'venue-group-chips',
}) => {
  const items = venueGroupChipItems(groups)
  if (items.length === 0) {
    return <EmptyLine data-testid={testId}>{emptyLabel}</EmptyLine>
  }
  return (
    <ChipRow data-testid={testId} onClick={event => event.stopPropagation()}>
      {items.map(group => (
        <GroupChip
          key={String(group._id)}
          to={`/venue-groups/${group._id}`}
          onClick={event => event.stopPropagation()}
        >
          {group.name}
        </GroupChip>
      ))}
    </ChipRow>
  )
}

const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0 0 8px;
`

const GroupChip = styled(Link)`
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 2px 10px;
  border-radius: 999px;
  border: 1px solid #d7e6a8;
  background: #f7fbec;
  color: #132d07;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  text-decoration: none;

  &:hover,
  &:focus {
    color: #0f2405;
    border-color: #b7c4ae;
    background: #fff;
  }
`

const EmptyLine = styled.p`
  margin: 0 0 8px;
  color: #6b6256;
  font-size: 13px;
`

export default VenueGroupMembershipChips
